webpackJsonp([1],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return b; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return k; });
/* unused harmony export cloneElement */
/* unused harmony export createContext */
/* unused harmony export createElement */
/* unused harmony export createRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return y; });
/* unused harmony export hydrate */
/* unused harmony export isValidElement */
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return D; });
/* unused harmony export toChildArray */
var n,l,u,i,t,o,r,f,e,c={},s=[],a=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,v=Array.isArray;function h(n,l){for(var u in l)n[u]=l[u];return n}function p(n){var l=n.parentNode;l&&l.removeChild(n)}function y(l,u,i){var t,o,r,f={};for(r in u)"key"==r?t=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):i),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps)void 0===f[r]&&(f[r]=l.defaultProps[r]);return d(l,f,t,o,null)}function d(n,i,t,o,r){var f={type:n,props:i,key:t,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==r?++u:r};return null==r&&null!=l.vnode&&l.vnode(f),f}function _(){return{current:null}}function k(n){return n.children}function b(n,l){this.props=n,this.context=l}function g(n,l){if(null==l)return n.__?g(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return"function"==typeof n.type?g(n):null}function m(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return m(n)}}function w(n){(!n.__d&&(n.__d=!0)&&t.push(n)&&!x.__r++||o!==l.debounceRendering)&&((o=l.debounceRendering)||r)(x)}function x(){var n,l,u,i,o,r,e,c;for(t.sort(f);n=t.shift();)n.__d&&(l=t.length,i=void 0,o=void 0,e=(r=(u=n).__v).__e,(c=u.__P)&&(i=[],(o=h({},r)).__v=r.__v+1,L(c,r,o,u.__n,void 0!==c.ownerSVGElement,null!=r.__h?[e]:null,i,null==e?g(r):e,r.__h),M(i,r),r.__e!=e&&m(r)),t.length>l&&t.sort(f));x.__r=0}function P(n,l,u,i,t,o,r,f,e,a){var h,p,y,_,b,m,w,x=i&&i.__k||s,P=x.length;for(u.__k=[],h=0;h<l.length;h++)if(null!=(_=u.__k[h]=null==(_=l[h])||"boolean"==typeof _||"function"==typeof _?null:"string"==typeof _||"number"==typeof _||"bigint"==typeof _?d(null,_,null,null,_):v(_)?d(k,{children:_},null,null,null):_.__b>0?d(_.type,_.props,_.key,_.ref?_.ref:null,_.__v):_)){if(_.__=u,_.__b=u.__b+1,null===(y=x[h])||y&&_.key==y.key&&_.type===y.type)x[h]=void 0;else for(p=0;p<P;p++){if((y=x[p])&&_.key==y.key&&_.type===y.type){x[p]=void 0;break}y=null}L(n,_,y=y||c,t,o,r,f,e,a),b=_.__e,(p=_.ref)&&y.ref!=p&&(w||(w=[]),y.ref&&w.push(y.ref,null,_),w.push(p,_.__c||b,_)),null!=b?(null==m&&(m=b),"function"==typeof _.type&&_.__k===y.__k?_.__d=e=C(_,e,n):e=$(n,_,y,x,b,e),"function"==typeof u.type&&(u.__d=e)):e&&y.__e==e&&e.parentNode!=n&&(e=g(y))}for(u.__e=m,h=P;h--;)null!=x[h]&&("function"==typeof u.type&&null!=x[h].__e&&x[h].__e==u.__d&&(u.__d=A(i).nextSibling),q(x[h],x[h]));if(w)for(h=0;h<w.length;h++)O(w[h],w[++h],w[++h])}function C(n,l,u){for(var i,t=n.__k,o=0;t&&o<t.length;o++)(i=t[o])&&(i.__=n,l="function"==typeof i.type?C(i,l,u):$(u,i,i,t,i.__e,l));return l}function S(n,l){return l=l||[],null==n||"boolean"==typeof n||(v(n)?n.some(function(n){S(n,l)}):l.push(n)),l}function $(n,l,u,i,t,o){var r,f,e;if(void 0!==l.__d)r=l.__d,l.__d=void 0;else if(null==u||t!=o||null==t.parentNode)n:if(null==o||o.parentNode!==n)n.appendChild(t),r=null;else{for(f=o,e=0;(f=f.nextSibling)&&e<i.length;e+=1)if(f==t)break n;n.insertBefore(t,o),r=o}return void 0!==r?r:t.nextSibling}function A(n){var l,u,i;if(null==n.type||"string"==typeof n.type)return n.__e;if(n.__k)for(l=n.__k.length-1;l>=0;l--)if((u=n.__k[l])&&(i=A(u)))return i;return null}function H(n,l,u,i,t){var o;for(o in u)"children"===o||"key"===o||o in l||T(n,o,null,u[o],i);for(o in l)t&&"function"!=typeof l[o]||"children"===o||"key"===o||"value"===o||"checked"===o||u[o]===l[o]||T(n,o,l[o],u[o],i)}function I(n,l,u){"-"===l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||a.test(l)?u:u+"px"}function T(n,l,u,i,t){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else{if("string"==typeof i&&(n.style.cssText=i=""),i)for(l in i)u&&l in u||I(n.style,l,"");if(u)for(l in u)i&&u[l]===i[l]||I(n.style,l,u[l])}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?i||n.addEventListener(l,o?z:j,o):n.removeEventListener(l,o?z:j,o);else if("dangerouslySetInnerHTML"!==l){if(t)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!==l&&"height"!==l&&"href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&"rowSpan"!==l&&"colSpan"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||!1===u&&"-"!==l[4]?n.removeAttribute(l):n.setAttribute(l,u))}}function j(n){return this.l[n.type+!1](l.event?l.event(n):n)}function z(n){return this.l[n.type+!0](l.event?l.event(n):n)}function L(n,u,i,t,o,r,f,e,c){var s,a,p,y,d,_,g,m,w,x,C,S,$,A,H,I=u.type;if(void 0!==u.constructor)return null;null!=i.__h&&(c=i.__h,e=u.__e=i.__e,u.__h=null,r=[e]),(s=l.__b)&&s(u);try{n:if("function"==typeof I){if(m=u.props,w=(s=I.contextType)&&t[s.__c],x=s?w?w.props.value:s.__:t,i.__c?g=(a=u.__c=i.__c).__=a.__E:("prototype"in I&&I.prototype.render?u.__c=a=new I(m,x):(u.__c=a=new b(m,x),a.constructor=I,a.render=B),w&&w.sub(a),a.props=m,a.state||(a.state={}),a.context=x,a.__n=t,p=a.__d=!0,a.__h=[],a._sb=[]),null==a.__s&&(a.__s=a.state),null!=I.getDerivedStateFromProps&&(a.__s==a.state&&(a.__s=h({},a.__s)),h(a.__s,I.getDerivedStateFromProps(m,a.__s))),y=a.props,d=a.state,a.__v=u,p)null==I.getDerivedStateFromProps&&null!=a.componentWillMount&&a.componentWillMount(),null!=a.componentDidMount&&a.__h.push(a.componentDidMount);else{if(null==I.getDerivedStateFromProps&&m!==y&&null!=a.componentWillReceiveProps&&a.componentWillReceiveProps(m,x),!a.__e&&null!=a.shouldComponentUpdate&&!1===a.shouldComponentUpdate(m,a.__s,x)||u.__v===i.__v){for(u.__v!==i.__v&&(a.props=m,a.state=a.__s,a.__d=!1),a.__e=!1,u.__e=i.__e,u.__k=i.__k,u.__k.forEach(function(n){n&&(n.__=u)}),C=0;C<a._sb.length;C++)a.__h.push(a._sb[C]);a._sb=[],a.__h.length&&f.push(a);break n}null!=a.componentWillUpdate&&a.componentWillUpdate(m,a.__s,x),null!=a.componentDidUpdate&&a.__h.push(function(){a.componentDidUpdate(y,d,_)})}if(a.context=x,a.props=m,a.__P=n,S=l.__r,$=0,"prototype"in I&&I.prototype.render){for(a.state=a.__s,a.__d=!1,S&&S(u),s=a.render(a.props,a.state,a.context),A=0;A<a._sb.length;A++)a.__h.push(a._sb[A]);a._sb=[]}else do{a.__d=!1,S&&S(u),s=a.render(a.props,a.state,a.context),a.state=a.__s}while(a.__d&&++$<25);a.state=a.__s,null!=a.getChildContext&&(t=h(h({},t),a.getChildContext())),p||null==a.getSnapshotBeforeUpdate||(_=a.getSnapshotBeforeUpdate(y,d)),P(n,v(H=null!=s&&s.type===k&&null==s.key?s.props.children:s)?H:[H],u,i,t,o,r,f,e,c),a.base=u.__e,u.__h=null,a.__h.length&&f.push(a),g&&(a.__E=a.__=null),a.__e=!1}else null==r&&u.__v===i.__v?(u.__k=i.__k,u.__e=i.__e):u.__e=N(i.__e,u,i,t,o,r,f,c);(s=l.diffed)&&s(u)}catch(n){u.__v=null,(c||null!=r)&&(u.__e=e,u.__h=!!c,r[r.indexOf(e)]=null),l.__e(n,u,i)}}function M(n,u){l.__c&&l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u)})}catch(n){l.__e(n,u.__v)}})}function N(l,u,i,t,o,r,f,e){var s,a,h,y=i.props,d=u.props,_=u.type,k=0;if("svg"===_&&(o=!0),null!=r)for(;k<r.length;k++)if((s=r[k])&&"setAttribute"in s==!!_&&(_?s.localName===_:3===s.nodeType)){l=s,r[k]=null;break}if(null==l){if(null===_)return document.createTextNode(d);l=o?document.createElementNS("http://www.w3.org/2000/svg",_):document.createElement(_,d.is&&d),r=null,e=!1}if(null===_)y===d||e&&l.data===d||(l.data=d);else{if(r=r&&n.call(l.childNodes),a=(y=i.props||c).dangerouslySetInnerHTML,h=d.dangerouslySetInnerHTML,!e){if(null!=r)for(y={},k=0;k<l.attributes.length;k++)y[l.attributes[k].name]=l.attributes[k].value;(h||a)&&(h&&(a&&h.__html==a.__html||h.__html===l.innerHTML)||(l.innerHTML=h&&h.__html||""))}if(H(l,d,y,o,e),h)u.__k=[];else if(P(l,v(k=u.props.children)?k:[k],u,i,t,o&&"foreignObject"!==_,r,f,r?r[0]:i.__k&&g(i,0),e),null!=r)for(k=r.length;k--;)null!=r[k]&&p(r[k]);e||("value"in d&&void 0!==(k=d.value)&&(k!==l.value||"progress"===_&&!k||"option"===_&&k!==y.value)&&T(l,"value",k,y.value,!1),"checked"in d&&void 0!==(k=d.checked)&&k!==l.checked&&T(l,"checked",k,y.checked,!1))}return l}function O(n,u,i){try{"function"==typeof n?n(u):n.current=u}catch(n){l.__e(n,i)}}function q(n,u,i){var t,o;if(l.unmount&&l.unmount(n),(t=n.ref)&&(t.current&&t.current!==n.__e||O(t,null,u)),null!=(t=n.__c)){if(t.componentWillUnmount)try{t.componentWillUnmount()}catch(n){l.__e(n,u)}t.base=t.__P=null,n.__c=void 0}if(t=n.__k)for(o=0;o<t.length;o++)t[o]&&q(t[o],u,i||"function"!=typeof n.type);i||null==n.__e||p(n.__e),n.__=n.__e=n.__d=void 0}function B(n,l,u){return this.constructor(n,u)}function D(u,i,t){var o,r,f;l.__&&l.__(u,i),r=(o="function"==typeof t)?null:t&&t.__k||i.__k,f=[],L(i,u=(!o&&t||i).__k=y(k,null,[u]),r||c,c,void 0!==i.ownerSVGElement,!o&&t?[t]:r?null:i.firstChild?n.call(i.childNodes):null,f,!o&&t?t:r?r.__e:i.firstChild,o),M(f,u)}function E(n,l){D(n,l,E)}function F(l,u,i){var t,o,r,f,e=h({},l.props);for(r in l.type&&l.type.defaultProps&&(f=l.type.defaultProps),u)"key"==r?t=u[r]:"ref"==r?o=u[r]:e[r]=void 0===u[r]&&void 0!==f?f[r]:u[r];return arguments.length>2&&(e.children=arguments.length>3?n.call(arguments,2):i),d(l.type,e,t||l.key,o||l.ref,null)}function G(n,l){var u={__c:l="__cC"+e++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,i;return this.getChildContext||(u=[],(i={})[l]=this,this.getChildContext=function(){return i},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(function(n){n.__e=!0,w(n)})},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n)}}),n.children}};return u.Provider.__=u.Consumer.contextType=u}n=s.slice,l={__e:function(n,l,u,i){for(var t,o,r;l=l.__;)if((t=l.__c)&&!t.__)try{if((o=t.constructor)&&null!=o.getDerivedStateFromError&&(t.setState(o.getDerivedStateFromError(n)),r=t.__d),null!=t.componentDidCatch&&(t.componentDidCatch(n,i||{}),r=t.__d),r)return t.__E=t}catch(l){n=l}throw n}},u=0,i=function(n){return null!=n&&void 0===n.constructor},b.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=h({},this.state),"function"==typeof n&&(n=n(h({},u),this.props)),n&&h(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),w(this))},b.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),w(this))},b.prototype.render=k,t=[],r="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,f=function(n,l){return n.__v.__b-l.__v.__b},x.__r=0,e=0;
//# sourceMappingURL=preact.module.js.map


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Loader = function Loader() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    "div",
    { className: "c-shop-loader" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])("div", { className: "rect1" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])("div", { className: "rect2" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])("div", { className: "rect3" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])("div", { className: "rect4" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])("div", { className: "rect5" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var OrderBy = function OrderBy(props) {
  function handleOrderChoice(e) {
    props.onSelectOrder(e.target.value);
  }

  var sortArray = [{ id: '', title: 'Sort by' }, { id: 'en', title: 'Sort by' }, { id: 'be', title: 'Sorteer op' }, { id: 'da', title: 'Sortér efter' }, { id: 'fi', title: 'Järjestä' }, { id: 'fr', title: 'Trier par' }, { id: 'fr-be', title: 'Trier par' }, { id: 'de', title: 'Sortieren nach' }, { id: 'it', title: 'Ordina per' }, { id: 'nl', title: 'Sorteer op' }, { id: 'no', title: 'Sorter etter' }, { id: 'es', title: 'Ordenar por' }, { id: 'sv', title: 'Sortera efter' }, { id: 'uk', title: 'Sort by' }, { id: 'gb', title: 'Sort by' }, { id: 'us', title: 'Sort by' }];
  var sortLabel = props.language ? sortArray.find(function (_ref) {
    var id = _ref.id;
    return id === props.language;
  }) : 'Sort by';
  sortLabel = sortLabel.title ? sortLabel.title : 'Sort by';

  var brandArray = [{ id: '', title: 'Brand' }, { id: 'en', title: 'Brand' }, { id: 'be', title: 'Merk' }, { id: 'da', title: 'Mærke' }, { id: 'fi', title: 'Brändi' }, { id: 'fr', title: 'Marque' }, { id: 'fr-be', title: 'Marque' }, { id: 'de', title: 'Marke' }, { id: 'it', title: 'Marca' }, { id: 'nl', title: 'Sorteer op' }, { id: 'no', title: 'Merke' }, { id: 'es', title: 'Marca' }, { id: 'sv', title: 'Märke' }, { id: 'uk', title: 'Brand' }, { id: 'gb', title: 'Brand' }, { id: 'us', title: 'Brand' }];
  var brandLabel = props.language ? brandArray.find(function (_ref2) {
    var id = _ref2.id;
    return id === props.language;
  }) : 'Brand';
  brandLabel = brandLabel.title ? brandLabel.title : 'Brand';

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-select-filter' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'select',
      {
        value: props.order,
        onChange: handleOrderChoice,
        disabled: props.postsLoading,
        className: 'c-shop-select-filter__select'
      },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'option',
        { value: '' },
        sortLabel
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'option',
        { value: 'title_asc' },
        brandLabel,
        ' (a-z)'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'option',
        { value: 'title_desc' },
        brandLabel,
        ' (z-a)'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OrderBy);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_App__ = __webpack_require__(32);



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var container = document.getElementById('js-shop-overview-app');

if (container) {
  var _container$dataset = container.dataset,
      filter = _container$dataset.filter,
      show = _container$dataset.show,
      showless = _container$dataset.showless,
      suggested = _container$dataset.suggested,
      items = _container$dataset.items,
      adding = _container$dataset.adding,
      readmore = _container$dataset.readmore,
      labelanimal = _container$dataset.labelanimal,
      labelcategory = _container$dataset.labelcategory,
      labelbrand = _container$dataset.labelbrand,
      one = _container$dataset.one,
      two = _container$dataset.two,
      three = _container$dataset.three,
      animal = _container$dataset.animal,
      brand = _container$dataset.brand,
      category = _container$dataset.category,
      suggestedanimal = _container$dataset.suggestedanimal,
      suggestedbrand = _container$dataset.suggestedbrand,
      suggestedcategory = _container$dataset.suggestedcategory,
      language = _container$dataset.language,
      loggedin = _container$dataset.loggedin;

  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["d" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__containers_App__["a" /* default */], {
    filterLabel: filter,
    showMore: show,
    showLess: showless,
    suggestedLabel: suggested,
    itemsLabel: items,
    addingLabel: adding,
    readMoreLabel: readmore,
    labelAnimal: labelanimal,
    labelCategory: labelcategory,
    labelBrand: labelbrand,
    uspOne: one,
    uspTwo: two,
    uspThree: three,
    startAnimal: animal,
    startBrand: brand,
    startCategory: category,
    suggestedAnimal: suggestedanimal,
    suggestedBrand: suggestedbrand,
    suggestedCategory: suggestedcategory,
    currentLanguage: language,
    loggedIn: loggedin
  }), container);
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_ProductsAPI__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_CategoriesAPI__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_BrandsAPI__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_AnimalsAPI__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_TableAPI__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Posts__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Filter__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Orderby__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_body_scroll_lock__ = __webpack_require__(45);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = {
      filterLabel: props.filterLabel,
      showMoreLabel: props.showMore,
      showLessLabel: props.showLess,
      suggestedLabel: props.suggestedLabel,
      itemsLabel: props.itemsLabel,
      addingLabel: props.addingLabel,
      readMoreLabel: props.readMoreLabel,
      labelAnimal: props.labelAnimal,
      labelCategory: props.labelCategory,
      labelBrand: props.labelBrand,
      uspOne: props.uspOne,
      uspTwo: props.uspTwo,
      uspThree: props.uspThree,
      isLoading: true,
      posts: [],
      allPosts: [],
      currentSlug: '',
      totalAmountProducts: null,
      categories: [],
      animals: [],
      brands: [],
      currentCategories: [],
      currentAnimals: [],
      currentBrands: [],
      startAnimal: props.startAnimal,
      startBrand: props.startBrand,
      startCategory: props.startCategory,
      suggestedAnimal: props.suggestedAnimal,
      suggestedBrand: props.suggestedBrand,
      suggestedCategory: props.suggestedCategory,
      currentLanguage: props.currentLanguage,
      count: 15,
      offset: 0,
      currentPage: 1,
      order: '',
      showAll: false,
      searchText: '',
      searchActive: false,
      filterMenu: false,
      resetUrlParam: false,
      loggedIn: props.loggedIn
    };
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.startAnimal) {
        var splitAnimal = this.state.startAnimal.split(';');
        this.setState({ currentAnimals: splitAnimal });
      }

      if (this.state.startBrand) {
        var splitBrand = this.state.startBrand.split(';');
        this.setState({ currentBrands: splitBrand });
      }

      if (this.state.startCategory) {
        var splitCategory = this.state.startCategory.split(';');
        this.setState({ currentCategories: splitCategory });
      }

      if (this.state.suggestedAnimal) {
        var splitAnimals = this.state.suggestedAnimal.split(';');
        this.setState({ suggestedAnimal: splitAnimals });
      }

      if (this.state.suggestedBrand) {
        var splitBrands = this.state.suggestedBrand.split(';');
        this.setState({ suggestedBrand: splitBrands });
      }

      if (this.state.suggestedCategory) {
        var splitCategories = this.state.suggestedCategory.split(';');
        this.setState({ suggestedCategory: splitCategories });
      }

      if (this.state.currentLanguage == 'en') {
        this.setState({ currentLanguage: '' });
      }

      if (!this.state.resetUrlParam) {
        this.fetchAnimalsFilterUrl();
        this.fetchCategoriesFilterUrl();
        this.fetchBrandsFilterUrl();
      }

      this.fetchCategoriesFilters().then(function () {
        _this2.fetchAnimalsFilters().then(function () {
          _this2.fetchBrandsFilters().then(function () {
            _this2.initiate();
            _this2.fetchAllPosts();
          }).catch(function (error) {});
        }).catch(function (error) {});
      }).catch(function (error) {});
    }
  }, {
    key: 'initiate',
    value: function initiate() {
      this.fetchProducts();
    }
  }, {
    key: 'fetchProducts',
    value: function fetchProducts() {
      var _this3 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_1__api_ProductsAPI__["a" /* default */].all(this.state).then(function (response) {
        _this3.setState({
          totalAmountProducts: response.headers.get('x-wp-total')
        });
        return response.json();
      }).then(function (data) {
        _this3.setState({
          posts: [].concat(_toConsumableArray(_this3.state.posts), _toConsumableArray(data)),
          isLoading: false
        });
      }).catch(function (error) {
        _this3.setState({
          fetchError: true,
          isLoading: false
        });
        throw Error('Fetching products failed: ' + error);
      });
    }

    // Fetch Categories

  }, {
    key: 'fetchCategoriesFilters',
    value: function fetchCategoriesFilters() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.setState({ isLoading: true });

        __WEBPACK_IMPORTED_MODULE_2__api_CategoriesAPI__["a" /* default */].all(_this4.state).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this4.setState(function () {
            return {
              categories: data,
              isLoading: false
            };
          }, _this4.setCurrentCategoryWithSlug);
          resolve();
        }).catch(function (error) {
          _this4.setState({
            fetchError: true,
            isLoading: false
          });
          reject();
          throw Error('Fetching products failed: ' + error);
        });
      });
    }
  }, {
    key: 'fetchCategoriesFilterUrl',
    value: function fetchCategoriesFilterUrl() {
      var _this5 = this;

      var currentURL = window.location.href;
      var splittedUrl = currentURL.split('/');
      var categoryOptions = ['product_category', 'product-category', 'vare-kategori', 'categorie-produit', 'produkt-kategorie', 'categoria-prodotto', 'product-categorie', 'produktkategori', 'produkt-kategori', 'categoria-producto'];

      categoryOptions.forEach(function (categoryOption) {
        if (currentURL.includes(categoryOption)) {
          var indexCategory = splittedUrl.indexOf(categoryOption);
          var indexCategoryElement = indexCategory + 1;
          // const categoryElement = splittedUrl[indexCategoryElement]

          // Look at the last part of the URL
          var categoryElement = splittedUrl[splittedUrl.length - 1] !== '' ? splittedUrl[splittedUrl.length - 1] : splittedUrl[splittedUrl.length - 2];

          console.log('Setting category category slug');
          _this5.setState({ currentSlug: categoryElement });
        }
      });
    }
  }, {
    key: 'setCurrentCategoryWithSlug',
    value: function setCurrentCategoryWithSlug() {
      var _this6 = this;

      if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
        console.log(this.state.currentSlug);
        var currentCategory = this.state.categories.filter(function (category) {
          return category.slug == _this6.state.currentSlug;
        });
        currentCategory = currentCategory[0];
        var subCategoryIds = [];
        var subSubCategoryIds = [];

        if (currentCategory) {
          // Get all subcategories that have the current category as parent
          var currentSubCategories = this.state.categories.filter(function (cat) {
            return cat.parent === currentCategory.id;
          });
          subCategoryIds = currentSubCategories.map(function (subcategory) {
            return subcategory.id;
          });

          // Get all subsubcategories that have one of the current subcategories as parent
          var currentSubSubCategories = this.state.categories.filter(function (cat) {
            return subCategoryIds.includes(cat.parent);
          });
          subSubCategoryIds = currentSubSubCategories.map(function (subsubcategory) {
            return subsubcategory.id;
          });
        }

        if (currentCategory && this.state.filterMenu === false) {
          var currentCategories = [].concat(_toConsumableArray(this.state.currentCategories));
          if (!currentCategories.includes(currentCategory.id)) {
            currentCategories.push(currentCategory.id);
            currentCategories = currentCategories.concat(subCategoryIds);
            currentCategories = currentCategories.concat(subSubCategoryIds);

            this.setState(function () {
              return {
                currentCategories: currentCategories,
                // posts: [],
                offset: 0
              };
            });
          }
        }
      }
    }

    // Fetch Animals

  }, {
    key: 'fetchAnimalsFilters',
    value: function fetchAnimalsFilters() {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        _this7.setState({ isLoading: true });

        __WEBPACK_IMPORTED_MODULE_4__api_AnimalsAPI__["a" /* default */].all(_this7.state).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this7.setState(function () {
            return {
              animals: data,
              isLoading: false
            };
          }, _this7.setCurrentAnimalWithSlug);
          resolve();
        }).catch(function (error) {
          _this7.setState({
            fetchError: true,
            isLoading: false
          });
          reject();
          throw Error('Fetching products failed: ' + error);
        });
      });
    }
  }, {
    key: 'fetchAnimalsFilterUrl',
    value: function fetchAnimalsFilterUrl() {
      var _this8 = this;

      var currentURL = window.location.href;
      var splittedUrl = currentURL.split('/');
      var animalCategoryOptions = ['animal_category', 'dyr', 'djur'];

      animalCategoryOptions.forEach(function (animalCategoryOption) {
        if (currentURL.includes(animalCategoryOption)) {
          var indexCategory = splittedUrl.indexOf(animalCategoryOption);
          var indexCategoryElement = indexCategory + 1;
          var categoryElement = splittedUrl[indexCategoryElement];
          console.log('Setting animal category slug');
          _this8.setState({ currentSlug: categoryElement });
        }
      });
    }
  }, {
    key: 'setCurrentAnimalWithSlug',
    value: function setCurrentAnimalWithSlug() {
      var _this9 = this;

      if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
        var currentAnimal = this.state.animals.filter(function (animal) {
          return animal.slug == _this9.state.currentSlug;
        });
        currentAnimal = currentAnimal[0];

        if (currentAnimal && this.state.filterMenu == false) {
          var currentAnimals = [].concat(_toConsumableArray(this.state.currentAnimals));
          if (!currentAnimals.includes(currentAnimal.id)) {
            currentAnimals.push(currentAnimal.id);

            this.setState(function () {
              return {
                currentAnimals: currentAnimals,
                offset: 0
              };
            });
          }
        }
      }
    }

    // Fetch Brands

  }, {
    key: 'fetchBrandsFilters',
    value: function fetchBrandsFilters() {
      var _this10 = this;

      return new Promise(function (resolve, reject) {
        _this10.setState({ isLoading: true });

        __WEBPACK_IMPORTED_MODULE_3__api_BrandsAPI__["a" /* default */].all(_this10.state).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this10.setState(function () {
            return {
              brands: data,
              isLoading: false
            };
          }, _this10.setCurrentBrandWithSlug);
          resolve();
        }).catch(function (error) {
          _this10.setState({
            fetchError: true,
            isLoading: false
          });
          reject();
          throw Error('Fetching products failed: ' + error);
        });
      });
    }
  }, {
    key: 'fetchBrandsFilterUrl',
    value: function fetchBrandsFilterUrl() {
      var _this11 = this;

      var currentURL = window.location.href;
      var splittedUrl = currentURL.split('/');
      var categoryOptions = ['product_category', 'vare-kategori', 'categorie-produit', 'produkt-kategorie', 'categoria-prodotto', 'product-categorie', 'produktkategori', 'produkt-kategori', 'categoria-producto'];

      categoryOptions.forEach(function (categoryOption) {
        if (currentURL.includes(categoryOption)) {
          var indexCategory = splittedUrl.indexOf(categoryOption);
          var indexCategoryElement = indexCategory + 1;
          // const categoryElement = splittedUrl[indexCategoryElement]

          // Look at the last part of the URL
          var categoryElement = splittedUrl[splittedUrl.length - 1] !== '' ? splittedUrl[splittedUrl.length - 1] : splittedUrl[splittedUrl.length - 2];
          console.log('Setting brand category slug');
          _this11.setState({ currentSlug: categoryElement });
        }
      });
    }
  }, {
    key: 'setCurrentBrandWithSlug',
    value: function setCurrentBrandWithSlug() {
      var _this12 = this;

      if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
        var currentBrand = this.state.brands.filter(function (category) {
          return category.slug == _this12.state.currentSlug;
        });
        currentBrand = currentBrand[0];

        if (currentBrand && this.state.filterMenu == false) {
          var currentBrands = [].concat(_toConsumableArray(this.state.currentBrands));
          if (!currentBrands.includes(currentBrand.id)) {
            currentBrands.push(currentBrand.id);

            this.setState(function () {
              return {
                currentBrands: currentBrands,
                offset: 0
              };
            });
          }
        }
      }
    }
  }, {
    key: 'fetchAllPosts',
    value: function fetchAllPosts() {
      var _this13 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_5__api_TableAPI__["a" /* default */].all(this.state).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this13.setState({
          allPosts: [].concat(_toConsumableArray(_this13.state.allPosts), _toConsumableArray(data)),
          isLoading: false
        });
      }).catch(function (error) {
        _this13.setState({
          fetchError: true,
          isLoading: false
        });
        throw Error('Fetching products failed: ' + error);
      });
    }

    // Add or remove filters from state

  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var currentElements = [].concat(_toConsumableArray(this.state[e.currentTarget.dataset.target]));
      var targetID = e.currentTarget.dataset.id * 1;

      if (currentElements.includes(targetID)) {
        currentElements = currentElements.filter(function (item) {
          return item !== targetID;
        });
      } else {
        currentElements.push(targetID);
      }

      // this.updateURLWithFilter(e.currentTarget.dataset.target, e.currentTarget.id); // Addon for later update

      this.setState(function () {
        var _ref;

        return _ref = {}, _defineProperty(_ref, e.currentTarget.dataset.target, currentElements), _defineProperty(_ref, 'posts', []), _defineProperty(_ref, 'offset', 0), _ref;
      }, this.initiate);
    }

    // Add selected filter to param

  }, {
    key: 'updateURLWithFilter',
    value: function updateURLWithFilter(target, name) {
      var _this14 = this;

      var animalsArray = [{ id: '', title: 'animal' }, { id: 'at', title: 'tier' }, { id: 'be', title: 'dier' }, { id: 'da', title: 'dyr' }, { id: 'fi', title: 'elain' }, { id: 'fr', title: 'animal' }, { id: 'fr-be', title: 'animal' }, { id: 'de', title: 'tier' }, { id: 'ga', title: 'animal' }, { id: 'it', title: 'animale' }, { id: 'lu', title: 'typ' }, { id: 'nl', title: 'dier' }, { id: 'no', title: 'dyr' }, { id: 'pl', title: 'zwierze' }, { id: 'pt-pt', title: 'animal' }, { id: 'es', title: 'animal' }, { id: 'sv', title: 'djur' }, { id: 'ch', title: 'tierart' }, { id: 'uk', title: 'animal' }, { id: 'gb', title: 'animal' }, { id: 'us', title: 'animal' }];
      var categoriesArray = [{ id: '', title: 'category' }, { id: 'at', title: 'kategorie' }, { id: 'be', title: 'categorie' }, { id: 'da', title: 'kategori' }, { id: 'fi', title: 'kategoria' }, { id: 'fr', title: 'categorie' }, { id: 'fr-be', title: 'categorie' }, { id: 'de', title: 'kategorie' }, { id: 'ga', title: 'category' }, { id: 'it', title: 'categoria' }, { id: 'lu', title: 'kategorie' }, { id: 'nl', title: 'categorie' }, { id: 'no', title: 'kategori' }, { id: 'pl', title: 'kategoria' }, { id: 'pt-pt', title: 'categoria' }, { id: 'es', title: 'categoria' }, { id: 'sv', title: 'kategori' }, { id: 'ch', title: 'kategorie' }, { id: 'uk', title: 'category' }, { id: 'gb', title: 'category' }, { id: 'us', title: 'category' }];
      var brandsArray = [{ id: '', title: 'brand' }, { id: 'at', title: 'marke' }, { id: 'be', title: 'merk' }, { id: 'da', title: 'maerke' }, { id: 'fi', title: 'brandi' }, { id: 'fr', title: 'marque' }, { id: 'fr-be', title: 'marque' }, { id: 'de', title: 'marke' }, { id: 'ga', title: 'brand' }, { id: 'it', title: 'marca' }, { id: 'lu', title: 'mark' }, { id: 'nl', title: 'merk' }, { id: 'no', title: 'merke' }, { id: 'pl', title: 'marka' }, { id: 'pt-pt', title: 'marka' }, { id: 'es', title: 'marca' }, { id: 'sv', title: 'varumarke' }, { id: 'ch', title: 'marke' }, { id: 'uk', title: 'brand' }, { id: 'gb', title: 'brand' }, { id: 'us', title: 'brand' }];

      if (target == 'currentAnimals') {
        var urlParam = animalsArray.find(function (_ref2) {
          var id = _ref2.id;
          return id === _this14.state.currentLanguage;
        }).title;
        if (history.pushState) this.paramToURL(urlParam, name);
      }

      if (target == 'currentCategories') {
        var _urlParam = categoriesArray.find(function (_ref3) {
          var id = _ref3.id;
          return id === _this14.state.currentLanguage;
        }).title;
        if (history.pushState) this.paramToURL(_urlParam, name);
      }

      if (target == 'currentBrands') {
        var _urlParam2 = brandsArray.find(function (_ref4) {
          var id = _ref4.id;
          return id === _this14.state.currentLanguage;
        }).title;
        if (history.pushState) this.paramToURL(_urlParam2, name);
      }
    }

    // Add filter param to url

  }, {
    key: 'paramToURL',
    value: function paramToURL(param, name) {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      urlParams.set(param, name);
      var params = '';

      // Add second param to url if it already exists
      if (queryString.includes(param)) {
        var stringToArray = queryString.replace('?', '').split('&');
        stringToArray.push(param + '=' + name);
        params = stringToArray.join('&').toString();
      } else {
        params = urlParams.toString();
      }

      // Remove specified param from url
      if (queryString.includes(name)) {
        var convertCurrentParams = queryString.replace('?', '').split('&');[].concat(_toConsumableArray(convertCurrentParams)).forEach(function (item) {
          if (item.includes(param + '=' + name)) convertCurrentParams.splice(convertCurrentParams.indexOf(item), 1);
        });

        params = convertCurrentParams.join('&').toString();
      }

      var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + params;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }

    // Add suggested filters to state

  }, {
    key: 'handleSuggested',
    value: function handleSuggested(e) {
      var currentElements = [].concat(_toConsumableArray(this.state[e.currentTarget.dataset.target]));
      var targetID = e.currentTarget.dataset.id * 1;

      if (currentElements.includes(targetID)) {
        currentElements = currentElements.filter(function (item) {
          return item !== targetID;
        });
      } else {
        currentElements.push(targetID);
      }

      this.setState(function () {
        var _ref5;

        return _ref5 = {}, _defineProperty(_ref5, e.currentTarget.dataset.target, currentElements), _defineProperty(_ref5, 'posts', []), _defineProperty(_ref5, 'offset', 0), _ref5;
      }, this.initiate);
    }

    // Remove filter from state

  }, {
    key: 'handleRemove',
    value: function handleRemove(e) {
      var currentElements = [].concat(_toConsumableArray(this.state[e.currentTarget.dataset.target]));
      var targetID = e.currentTarget.dataset.id * 1;
      currentElements = currentElements.filter(function (item) {
        return item !== targetID;
      });

      this.setState(function () {
        var _ref6;

        return _ref6 = {}, _defineProperty(_ref6, e.currentTarget.dataset.target, currentElements), _defineProperty(_ref6, 'posts', []), _defineProperty(_ref6, 'offset', 0), _defineProperty(_ref6, 'currentSlug', ''), _defineProperty(_ref6, 'filterMenu', true), _defineProperty(_ref6, 'resetUrlParam', true), _ref6;
      }, this.initiate);
    }
  }, {
    key: 'handleRemoveSearch',
    value: function handleRemoveSearch(e) {
      this.setState(function () {
        return {
          searchText: '',
          posts: [],
          // allPosts: [],
          offset: 0,
          currentSlug: '',
          filterMenu: true,
          resetUrlParam: true
        };
      }, this.initiate);
    }
  }, {
    key: 'handleReset',
    value: function handleReset(e) {
      this.setState(function () {
        return {
          searchText: '',
          posts: [],
          // allPosts: [],
          offset: 0,
          currentSlug: '',
          filterMenu: true,
          resetUrlParam: true,
          currentCategories: [],
          currentAnimals: [],
          currentBrands: []
        };
      }, this.initiate);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      // Add start filters to the state
      var splitAnimal = this.state.startAnimal ? this.state.startAnimal.split(';') : [];
      var splitBrand = this.state.startBrand ? this.state.startBrand.split(';') : [];
      var splitCategory = this.state.startCategory ? this.state.startCategory.split(';') : [];

      // remove added params
      if (history.pushState) {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);

        if (urlParams.size > 0) {
          var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
          window.history.pushState({ path: newUrl }, '', newUrl);
        }
      }

      this.setState(function () {
        return {
          currentCategories: splitCategory,
          currentAnimals: splitAnimal,
          currentBrands: splitBrand,
          // searchText: '',
          posts: [],
          // allPosts: [],
          offset: 0,
          resetUrlParam: true
        };
      }, this.initiate);
    }
  }, {
    key: 'handleToggle',
    value: function handleToggle() {
      if (this.state.filterActive) {
        Object(__WEBPACK_IMPORTED_MODULE_10_body_scroll_lock__["a" /* clearAllBodyScrollLocks */])();
      }
      this.setState({ filterActive: !this.state.filterActive });
    }
  }, {
    key: 'handleOrderChoice',
    value: function handleOrderChoice(order) {
      this.setState({
        order: order,
        posts: [],
        // allPosts: [],
        offset: 0
      }, this.initiate);
    }
  }, {
    key: 'handleShowMore',
    value: function handleShowMore(e) {
      var _this15 = this;

      this.setState(function (prevState) {
        return {
          offset: prevState.offset + _this15.state.count,
          count: _this15.state.count + _this15.state.count
        };
      }, this.fetchProducts);
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchText) {
      this.setState({
        searchText: searchText
      });
    }
  }, {
    key: 'handleSearchSubmit',
    value: function handleSearchSubmit() {
      this.setState({
        posts: []
        // allPosts: []
      }, this.initiate);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this16 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-overview__app-container' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-overview__filter-top-bar u-flex u-flex-sb' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            {
              className: 'c-shop-overview__filter-button',
              onClick: this.handleToggle.bind(this)
            },
            this.state.filterActive ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'svg',
              { className: 'c-icon c-shop-overview__filter-icon active' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#close', xlinkHref: '#close' })
            ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'svg',
              { className: 'c-icon c-shop-overview__filter-icon' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#filter', xlinkHref: '#filter' })
            ),
            'Filter'
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            { className: 'c-shop-overview__filter-button' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_8__components_Orderby__["a" /* default */], {
              order: this.state.order,
              onSelectOrder: this.handleOrderChoice.bind(this),
              postsLoading: this.state.isLoading,
              language: this.state.currentLanguage
            })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { 'class': 'c-shop-overview__filter-container' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_7__Filter__["a" /* default */], {
            posts: this.state.posts,
            allPosts: this.state.allPosts,
            categories: this.state.categories,
            animals: this.state.animals,
            brands: this.state.brands,
            labelAnimal: this.state.labelAnimal,
            labelCategory: this.state.labelCategory,
            labelBrand: this.state.labelBrand,
            startAnimal: this.state.startAnimal,
            startBrand: this.state.startBrand,
            startCategory: this.state.startCategory,
            currentCategories: this.state.currentCategories,
            currentAnimals: this.state.currentAnimals,
            currentBrands: this.state.currentBrands,
            handleChange: this.handleChange.bind(this),
            handleClick: this.handleClick.bind(this),
            filterActive: this.state.filterActive,
            handleToggle: this.handleToggle.bind(this),
            isLoading: this.state.isLoading,
            placeholder: this.state.filterLabel,
            filterLabel: this.state.filterLabel,
            showMoreLabel: this.state.showMoreLabel,
            showLessLabel: this.state.showLessLabel,
            handleRemove: this.handleRemove.bind(this),
            handleRemoveSearch: this.handleRemoveSearch.bind(this),
            handleReset: this.handleReset.bind(this),
            searchText: this.state.searchText,
            language: this.state.currentLanguage
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { 'class': 'c-shop-overview__posts-wrapper' },
          this.state.posts.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            { 'class': 'c-shop-overview__posts-container' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_6__components_Posts__["a" /* default */], {
              posts: this.state.posts,
              offset: this.state.offset,
              itemsLabel: this.state.itemsLabel,
              addLabel: this.state.addingLabel,
              readMoreLabel: this.state.readMoreLabel,
              suggestedLabel: this.state.suggestedLabel,
              loading: this.state.isLoading,
              nrAll: this.state.totalAmountProducts,
              count: this.state.count,
              uspOne: this.state.uspOne,
              uspTwo: this.state.uspTwo,
              uspThree: this.state.uspThree,
              suggestedAnimal: this.state.suggestedAnimal,
              suggestedBrand: this.state.suggestedBrand,
              suggestedCategory: this.state.suggestedCategory,
              categories: this.state.categories,
              animals: this.state.animals,
              brands: this.state.brands,
              handleSuggested: this.handleSuggested.bind(this),
              order: this.state.order,
              handleOrderChoice: this.handleOrderChoice.bind(this),
              currentLanguage: this.state.currentLanguage,
              handleShowMore: this.handleShowMore.bind(this),
              searchText: this.state.filterLabel,
              onSearch: this.handleSearch.bind(this),
              onSubmit: this.handleSearchSubmit.bind(this),
              loggedIn: this.state.loggedIn
            })
          ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* Fragment */],
            null,
            this.state.isLoading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_9__components_Loader__["a" /* default */], null) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'div',
              { className: 'c-shop-overview__no-posts' },
              'No results',
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                'div',
                {
                  className: 'c-shop-overview__reset',
                  onClick: function onClick() {
                    _this16.handleClick();
                  }
                },
                'Reset filters'
              )
            )
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductsAPI = function () {
  function ProductsAPI() {
    _classCallCheck(this, ProductsAPI);
  }

  _createClass(ProductsAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.getUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(params) {
      var currentCategories = params.currentCategories,
          currentAnimals = params.currentAnimals,
          currentBrands = params.currentBrands,
          count = params.count,
          offset = params.offset,
          currentLanguage = params.currentLanguage,
          order = params.order,
          searchText = params.searchText;


      var orderby = this.orderQuery(order);
      var filterCategories = currentCategories.length > 0 ? '&product_cat=' + currentCategories : '';
      var filterAnimals = currentAnimals.length > 0 ? '&animal_category=' + currentAnimals : '';
      var filterBrands = currentBrands.length > 0 ? '&brand=' + currentBrands : '';

      var query = filterCategories + filterAnimals + filterBrands;
      var countQuery = count === 999 ? 'custom_per_page=' + count : 'per_page=' + count;
      var root = window.location.origin;
      var lang = currentLanguage == 'en' ? '' : currentLanguage;

      var search = searchText ? '&search=' + searchText : '';

      // console.log(`${root}/${lang}/wp-json/wp/v2/product/?${countQuery}&offset=${offset}${query}${orderby}${search}`);
      return root + '/' + lang + '/wp-json/wp/v2/product/?' + countQuery + '&offset=' + offset + query + orderby + search;
    }
  }, {
    key: 'orderQuery',
    value: function orderQuery(order) {
      if (order === 'title_asc') {
        return '&orderby=title&order=asc';
      } else if (order === 'title_desc') {
        return '&orderby=title&order=desc';
      } else {
        return '&orderby=title&order=asc';
      }
    }
  }]);

  return ProductsAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProductsAPI);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoriesAPI = function () {
  function CategoriesAPI() {
    _classCallCheck(this, CategoriesAPI);
  }

  _createClass(CategoriesAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.getUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(params) {
      var lang = params.currentLanguage == 'en' ? '' : params.currentLanguage;
      var root = window.location.origin;
      var search = params.searchText ? '&search=' + params.searchText : '';

      return root + '/' + lang + '/wp-json/wp/v2/product_cat/?per_page=100' + search;
    }
  }]);

  return CategoriesAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (CategoriesAPI);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BrandsAPI = function () {
  function BrandsAPI() {
    _classCallCheck(this, BrandsAPI);
  }

  _createClass(BrandsAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.getUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(params) {
      var lang = params.currentLanguage == 'en' ? '' : params.currentLanguage;
      var root = window.location.origin;
      var search = params.searchText ? '&search=' + params.searchText : '';

      return root + '/' + lang + '/wp-json/wp/v2/brand/?per_page=100' + search;
    }
  }]);

  return BrandsAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrandsAPI);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnimalsAPI = function () {
  function AnimalsAPI() {
    _classCallCheck(this, AnimalsAPI);
  }

  _createClass(AnimalsAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.getUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(params) {
      var lang = params.currentLanguage == 'en' ? '' : params.currentLanguage;
      var root = window.location.origin;
      var search = params.searchText ? '&search=' + params.searchText : '';

      return root + '/' + lang + '/wp-json/wp/v2/animal_category/?per_page=100' + search;
    }
  }]);

  return AnimalsAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (AnimalsAPI);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableAPI = function () {
  function TableAPI() {
    _classCallCheck(this, TableAPI);
  }

  _createClass(TableAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.getUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'getUrl',
    value: function getUrl(params) {
      var currentCategories = params.currentCategories,
          currentAnimals = params.currentAnimals,
          currentBrands = params.currentBrands,
          count = params.count,
          offset = params.offset,
          currentLanguage = params.currentLanguage;


      var filterCategories = currentCategories.length > 0 ? '&product_cat=' + currentCategories : '';
      var filterAnimals = currentAnimals.length > 0 ? '&animal_category=' + currentAnimals : '';
      var filterBrands = currentBrands.length > 0 ? '&brand=' + currentBrands : '';

      var query = filterCategories + filterAnimals + filterBrands;
      var root = window.location.origin;
      var lang = currentLanguage == 'en' ? '' : currentLanguage;

      return root + '/' + lang + '/wp-json/wp/v2/product/?per_page=100' + query;
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }]);

  return TableAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (TableAPI);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Post__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__USPRow__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Orderby__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SearchFilter__ = __webpack_require__(41);







// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Posts = function Posts(props) {
  var posts = props.posts;

  var offset = props.offset;
  var activeClass = props.showAll ? 'active' : '';
  var addLabel = props.addLabel ? props.addLabel : 'Add';
  var readMoreLabel = props.readMoreLabel ? props.readMoreLabel : 'Read more';
  var suggestedLabel = props.suggestedLabel ? props.suggestedLabel : 'Suggested filters:';
  var uspOne = props.uspOne ? props.uspOne : '';
  var uspTwo = props.uspTwo ? props.uspTwo : '';
  var uspThree = props.uspThree ? props.uspThree : '';
  var suggestedAnimal = props.suggestedAnimal ? props.suggestedAnimal : false;
  var suggestedBrand = props.suggestedBrand ? props.suggestedBrand : false;
  var suggestedCategory = props.suggestedCategory ? props.suggestedCategory : false;
  var language = props.currentLanguage !== '' ? props.currentLanguage : 'en';
  var searchPlaceholder = props.searchText ? props.searchText : '';
  var loggedIn = props.loggedIn ? props.loggedIn : '';

  var shownArray = [{ id: '', title: 'shown' }, { id: 'en', title: 'shown' }, { id: 'be', title: 'getoond' }, { id: 'da', title: 'vist' }, { id: 'fi', title: 'näytetty' }, { id: 'fr', title: 'montré' }, { id: 'fr-be', title: 'montré' }, { id: 'de', title: 'gezeigt' }, { id: 'it', title: 'mostrato' }, { id: 'nl', title: 'getoond' }, { id: 'no', title: 'vist' }, { id: 'es', title: 'mostrado' }, { id: 'sv', title: 'visad' }, { id: 'uk', title: 'shown' }, { id: 'gb', title: 'shown' }, { id: 'us', title: 'shown' }];
  var shownLabel = language ? shownArray.find(function (_ref) {
    var id = _ref.id;
    return id === language;
  }) : 'shown';
  shownLabel = shownLabel.title ? shownLabel.title : 'Shown';

  var loadArray = [{ id: '', title: 'Load more' }, { id: 'en', title: 'Load more' }, { id: 'be', title: 'Laad meer' }, { id: 'da', title: 'Indlæs mere' }, { id: 'fi', title: 'Lataa lisää' }, { id: 'fr', title: 'Charger plus' }, { id: 'fr-be', title: 'Charger plus' }, { id: 'de', title: 'Mehr laden' }, { id: 'it', title: 'Carica altro' }, { id: 'nl', title: 'Laad meer' }, { id: 'no', title: 'Last mer' }, { id: 'es', title: 'Cargar más' }, { id: 'sv', title: 'Ladda mer' }, { id: 'uk', title: 'Load more' }, { id: 'gb', title: 'Load more' }, { id: 'us', title: 'Load more' }];
  var loadLabel = language ? loadArray.find(function (_ref2) {
    var id = _ref2.id;
    return id === language;
  }) : 'Load more';
  loadLabel = loadLabel.title ? loadLabel.title : 'Load more';

  var loadedArray = [{ id: '', title: 'All loaded' }, { id: 'en', title: 'All loaded' }, { id: 'be', title: 'Alles geladen' }, { id: 'da', title: 'Alt indlæst' }, { id: 'fi', title: 'Kaikki ladattu' }, { id: 'fr', title: 'Tout chargé' }, { id: 'fr-be', title: 'Tout chargé' }, { id: 'de', title: 'Alles geladen' }, { id: 'it', title: 'Tutto caricato' }, { id: 'nl', title: 'Alles geladen' }, { id: 'no', title: 'Alt lastet' }, { id: 'es', title: 'Todo cargado' }, { id: 'sv', title: 'Allt laddat' }, { id: 'uk', title: 'All loaded' }, { id: 'gb', title: 'All loaded' }, { id: 'us', title: 'All loaded' }];
  var loadedLabel = language ? loadedArray.find(function (_ref3) {
    var id = _ref3.id;
    return id === language;
  }) : 'All loaded';
  loadedLabel = loadedLabel.title ? loadedLabel.title : 'All loaded';

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-overview__posts u-flex', 'data-lang': '' + language },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-overview__posts-top-bar u-flex u-flex-sb' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-overview__posts-top-content u-flex u-flex-v-center' },
        suggestedAnimal.length || suggestedBrand.length || suggestedCategory.length ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* Fragment */],
          null,
          suggestedLabel,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            { className: 'c-shop-overview__suggested-filters u-flex' },
            suggestedAnimal.length ? suggestedAnimal.map(function (item) {
              var currentCategory = props.animals.filter(function (category) {
                return category.id == item;
              });
              var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
              var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
              if (!currentCategoryName.length) return;
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Item, { handleSuggested: props.handleSuggested, id: currentCategoryID, target: 'currentAnimals', item: currentCategoryName });
            }) : null,
            suggestedBrand.length ? suggestedBrand.map(function (item) {
              var currentCategory = props.brands.filter(function (category) {
                return category.id == item;
              });
              var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
              var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
              if (!currentCategoryName.length) return;
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Item, { handleSuggested: props.handleSuggested, id: currentCategoryID, target: 'currentBrands', item: currentCategoryName });
            }) : null,
            suggestedCategory.length ? suggestedCategory.map(function (item) {
              var currentCategory = props.categories.filter(function (category) {
                return category.id == item;
              });
              var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
              var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
              if (!currentCategoryName.length) return;
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Item, { handleSuggested: props.handleSuggested, id: currentCategoryID, target: 'currentCategories', item: currentCategoryName });
            }) : null
          )
        ) : null
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_5__components_SearchFilter__["a" /* default */], {
        searchText: '',
        onSearch: props.onSearch,
        onSubmit: props.onSubmit,
        placeholder: searchPlaceholder,
        searchActive: props.searchActive,
        isLoading: props.isLoading
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { 'class': 'c-shop-overview__count u-flex u-flex-sb' },
      '(',
      props.nrAll,
      ') ',
      props.itemsLabel,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { 'class': 'u-hide-on-small' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_4__Orderby__["a" /* default */], {
          order: props.order,
          onSelectOrder: props.handleOrderChoice,
          postsLoading: props.loading,
          language: language
        })
      )
    ),
    posts.map(function (post, index) {
      if (index == 6 && uspOne) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_2__USPRow__["a" /* default */], {
          uspOne: uspOne,
          uspTwo: uspTwo,
          uspThree: uspThree
        });
      } else {
        if (offset == 0) {
          if (index < 15) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Post__["a" /* default */], { key: post.id, post: post, add: addLabel, readMore: readMoreLabel, language: language, loggedIn: loggedIn });
          }
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Post__["a" /* default */], { key: post.id, post: post, add: addLabel, readMore: readMoreLabel, language: language, loggedIn: loggedIn });
        }
      }
    }),
    props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_3__Loader__["a" /* default */], null) : null,
    props.nrAll > props.count && !props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-overview__toggle-button-container' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-overview__posts-count' },
        posts.length,
        ' of ',
        props.nrAll,
        ' ',
        shownLabel
      ),
      !(props.nrAll == posts.length) ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-overview__toggle-button u-flex ' + activeClass, onClick: props.handleShowMore },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-overview__show-more' },
          loadLabel
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-overview__show-less' },
          loadedLabel
        )
      ) : null
    ) : null
  );
};

var Item = function Item(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-filters__item c-shop-filters__suggested-item', onClick: props.handleSuggested, 'data-id': props.id, 'data-target': props.target, 'data-name': props.item },
    props.label ? props.label : props.item
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Posts);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Post = function Post(props) {
  var post = props.post;


  var title = post.title.rendered;
  var image = post.featured_image_link;
  var content = post.excerpt.rendered;
  var shortContent = content ? content.slice(0, 150) : false;
  var displayShortContent = shortContent.length > 1 ? shortContent + '...' : false;
  var renderContent = content.length < 150 ? content : displayShortContent;
  var price = post.price && post.price != 0 && props.language !== 'en' ? post.price : false;
  var currency = post.currency_symbol;
  var volume = post.product_attributes ? post.product_attributes : false;
  var productType = post.product_type ? post.product_type : false;
  var anchorPet = props.add;
  var anchorVet = props.readMore;
  var formattedPrice = price ? props.language == 'no' || props.language == 'da' || props.language == 'sv' ? price.replace('.', ',') + ' ' + currency : currency + price.replace('.', ',') : false;
  var url = post.link;
  var loggedIn = props.loggedIn;

  var fromArray = [{ id: '', title: 'From' }, { id: 'en', title: 'From' }, { id: 'at', title: 'Ab' }, { id: 'be', title: 'Vanaf' }, { id: 'da', title: 'Fra' }, { id: 'fi', title: 'Alkaen' }, { id: 'fr', title: 'A partir de' }, { id: 'fr-be', title: 'A partir de' }, { id: 'de', title: 'Ab' }, { id: 'ga', title: 'From' }, { id: 'it', title: 'A partire da' }, { id: 'lu', title: 'Ab' }, { id: 'nl', title: 'Vanaf' }, { id: 'no', title: 'Fra' }, { id: 'pl', title: 'Od' }, { id: 'pt-pt', title: 'A partir de' }, { id: 'es', title: 'Desde' }, { id: 'sv', title: 'Från' }, { id: 'ch', title: 'Ab' }, { id: 'uk', title: 'From' }, { id: 'gb', title: 'From' }, { id: 'us', title: 'From' }];
  var fromLabel = productType == 'variable' && price ? fromArray.find(function (_ref) {
    var id = _ref.id;
    return id === props.language;
  }) : false;
  fromLabel = fromLabel.title ? fromLabel.title : false;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'a',
    { href: url, className: 'c-shop-overview__post c-shop-item' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-item__image-wrapper' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-item__image-container u-image' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('img', { src: image, className: 'c-shop-item__image u-image__background', alt: title })
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-item__content-container' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'h3',
        { className: 'c-shop-item__title' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('div', { dangerouslySetInnerHTML: { __html: title } })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'p',
        { className: 'c-shop-item__content' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('div', { dangerouslySetInnerHTML: { __html: renderContent } })
      )
    ),
    productType != 'variable' && props.language !== 'en' && loggedIn == "true" || props.language !== 'en' && loggedIn == "true" ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-item__button-container u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-item__price-container' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-item__volume' },
          volume
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-item__button' },
        anchorVet,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'svg',
          { className: 'c-icon c-shop-item__icon' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#plus', xlinkHref: '#plus' })
        )
      )
    ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-item__button-container u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-item__price-container' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-item__volume' },
          volume
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-item__button' },
        anchorVet,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'svg',
          { className: 'c-icon c-shop-item__icon' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#plus', xlinkHref: '#plus' })
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Post);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var USPRow = function USPRow(props) {
  var uspOne = props.uspOne ? props.uspOne : '';
  var uspTwo = props.uspTwo ? props.uspTwo : '';
  var uspThree = props.uspThree ? props.uspThree : '';

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-usps u-flex' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-usps__usp u-flex u-flex-v-center' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'svg',
        { className: 'c-icon c-shop-usps__icon' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#check-v2', xlinkHref: '#check-v2' })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('div', { dangerouslySetInnerHTML: { __html: uspOne } })
    ),
    uspTwo ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-usps__usp u-flex u-flex-v-center' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'svg',
        { className: 'c-icon c-shop-usps__icon' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#check-v2', xlinkHref: '#check-v2' })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('div', { dangerouslySetInnerHTML: { __html: uspTwo } })
    ) : false,
    uspThree ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-usps__usp u-flex u-flex-v-center' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'svg',
        { className: 'c-icon c-shop-usps__icon' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#check-v2', xlinkHref: '#check-v2' })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('div', { dangerouslySetInnerHTML: { __html: uspThree } })
    ) : false
  );
};

/* harmony default export */ __webpack_exports__["a"] = (USPRow);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var SearchFilter = function SearchFilter(props) {
  var showSearch = props.searchActive ? 'active' : '';

  function handleSearch(e) {
    props.onSearch(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    props.onSubmit();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-search-filter ' + showSearch },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'form',
      { onSubmit: handleSubmit },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('input', {
        type: 'search',
        placeholder: props.placeholder,
        value: props.searchText,
        onChange: handleSearch,
        className: 'c-shop-search-filter__search-field'
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('input', {
        type: 'submit',
        value: '',
        disabled: props.postsLoading ? true : false,
        className: 'c-shop-search-filter__submit'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchFilter);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkboxes__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Filters__ = __webpack_require__(44);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.state = {
      error: false,
      isLoading: false
    };
    return _this;
  }

  _createClass(Filter, [{
    key: 'render',
    value: function render() {
      var filterActive = this.props.filterActive;

      var activeClass = filterActive ? 'active' : '';

      // Count categories
      var categoriesCount = {};
      var countcategories = [];
      var animalsCount = {};
      var countanimals = [];
      var brandsCount = {};
      var countbrands = [];

      this.props.allPosts.map(function (cat) {
        cat.product_category_name.forEach(function (cat) {
          countcategories.push(cat);
        });

        cat.animal_category_name.forEach(function (cat) {
          countanimals.push(cat);
        });

        cat.brand_category_name.forEach(function (cat) {
          countbrands.push(cat);
        });
      });

      countcategories.forEach(function (x) {
        categoriesCount[x] = (categoriesCount[x] || 0) + 1;
      });

      countanimals.forEach(function (x) {
        animalsCount[x] = (animalsCount[x] || 0) + 1;
      });

      countbrands.forEach(function (x) {
        brandsCount[x] = (brandsCount[x] || 0) + 1;
      });

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-filter ' + activeClass },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-filter__filter-label u-hide-on-medium-down' },
          this.props.filterLabel
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_Filters__["a" /* default */], {
          currentCategories: this.props.currentCategories,
          currentAnimals: this.props.currentAnimals,
          currentBrands: this.props.currentBrands,
          allCategories: this.props.categories,
          allAnimals: this.props.animals,
          allBrands: this.props.brands,
          searchText: this.props.searchText,
          handleRemove: this.props.handleRemove,
          handleRemoveSearch: this.props.handleRemoveSearch,
          handleReset: this.props.handleReset,
          handleChange: this.props.handleChange,
          language: this.props.language
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-filter__filter-wrapper' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            { className: 'c-shop-filter__wrapper' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'div',
              { className: 'c-shop-filter__top-bar u-hide-on-large-up' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                'div',
                { className: 'c-shop-filter__top-bar-title' },
                this.props.filterLabel
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                'svg',
                {
                  className: 'c-icon c-shop-filter__filter-icon',
                  onClick: this.props.handleToggle
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#close', xlinkHref: '#close' })
              )
            ),
            !this.props.startAnimal ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Checkboxes__["a" /* default */], {
              handleChange: this.props.handleChange,
              handleClick: this.props.handleClick,
              showMoreLabel: this.props.showMoreLabel,
              showLessLabel: this.props.showLessLabel,
              target: 'currentAnimals',
              items: this.props.animals,
              currentElements: this.props.currentAnimals,
              type: 'animals',
              title: this.props.labelAnimal,
              isLoading: this.props.isLoading,
              counter: animalsCount,
              allPosts: this.props.allPosts,
              handleClose: this.props.handleToggle
            }) : false,
            !this.props.startCategory ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Checkboxes__["a" /* default */], {
              handleChange: this.props.handleChange,
              handleClick: this.props.handleClick,
              showMoreLabel: this.props.showMoreLabel,
              showLessLabel: this.props.showLessLabel,
              target: 'currentCategories',
              items: this.props.categories,
              currentElements: this.props.currentCategories,
              type: 'categories',
              title: this.props.labelCategory,
              isLoading: this.props.isLoading,
              counter: categoriesCount,
              allPosts: this.props.allPosts,
              handleClose: this.props.handleToggle
            }) : false,
            !this.props.startBrand ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Checkboxes__["a" /* default */], {
              handleChange: this.props.handleChange,
              handleClick: this.props.handleClick,
              showMoreLabel: this.props.showMoreLabel,
              showLessLabel: this.props.showLessLabel,
              target: 'currentBrands',
              items: this.props.brands,
              currentElements: this.props.currentBrands,
              type: 'brand',
              title: this.props.labelBrand,
              isLoading: this.props.isLoading,
              counter: brandsCount,
              allPosts: this.props.allPosts,
              handleClose: this.props.handleToggle
            }) : false
          )
        )
      );
    }
  }]);

  return Filter;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Checkboxes = function (_Component) {
  _inherits(Checkboxes, _Component);

  function Checkboxes(props) {
    _classCallCheck(this, Checkboxes);

    var _this = _possibleConstructorReturn(this, (Checkboxes.__proto__ || Object.getPrototypeOf(Checkboxes)).call(this, props));

    _this.state = {
      collapsed: false
    };
    return _this;
  }

  _createClass(Checkboxes, [{
    key: 'handleDropdown',
    value: function handleDropdown(e) {
      var container = e.currentTarget.closest('.js-target-click');
      container.classList.toggle('activated');
    }
  }, {
    key: 'handleOptions',
    value: function handleOptions(e) {
      this.state.collapsed ? this.setState({ collapsed: false }) : this.setState({ collapsed: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.props.items;

      // Order and group items based on the subfix
      if (this.props.target === 'currentCategories') {
        items = this.props.items.map(function (item) {
          item.custom_name = item.name.includes(' | ') ? item.name.split(' | ')[1] + ' | ' + item.name.split(' | ')[0] : item.name;

          return item;
        });

        items.sort(function (a, b) {
          return a.custom_name.localeCompare(b.custom_name);
        });
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-filter__checkboxes js-target-click' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          {
            className: 'c-shop-filter__title js-target-trigger',
            onClick: this.handleDropdown.bind(this)
          },
          this.props.title,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'svg',
            { className: 'c-icon c-shop-filter__dropdown u-hide-on-large-down' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#chevron-down', xlinkHref: '#chevron-down' })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { className: 'c-shop-filter__options js-target-target' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            { className: 'c-shop-filter__back u-flex u-flex-sb u-hide-on-medium-up' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'div',
              {
                className: 'c-shop-filter__back-button js-target-trigger-back',
                onClick: this.handleDropdown.bind(this)
              },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                'svg',
                { className: 'c-icon c-shop-filter__back-icon' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#arrow-left', xlinkHref: '#arrow-left' })
              ),
              'Back'
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'div',
              {
                className: 'c-shop-filter__filter-button',
                onClick: this.props.handleClick
              },
              'Clear all filters'
            )
          ),
          this.state.collapsed ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* Fragment */],
            null,
            items.map(function (item, index) {
              var catCounter = _this2.props.counter[item.name] > 0 ? '(' + _this2.props.counter[item.name] + ')' : '';
              if (item.name == 'Omega-3' && catCounter > 1) catCounter--;

              // Use custom name if available
              var itemName = item.custom_name ? item.custom_name.replace('amp;', '') : item.name.replace('amp;', '');
              var active = _this2.props.currentElements.includes(item.id) ? 'chosen' : '';

              if (_this2.props.counter[item.name] >= 1) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                  'div',
                  {
                    className: 'c-shop-filter__checkbox ' + active,
                    'data-loop': index
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('input', {
                    type: 'checkbox',
                    name: item.name,
                    value: '1',
                    checked: _this2.props.currentElements.includes(item.name),
                    id: item.name,
                    className: 'c-shop-filter__input',
                    onClick: _this2.props.handleChange,
                    'data-target': _this2.props.target,
                    'data-id': item.id,
                    disabled: _this2.props.isLoading
                  }),
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                    'label',
                    { className: 'c-shop-filter__label', 'for': item.name },
                    itemName,
                    ' ',
                    catCounter
                  )
                );
              }
            })
          ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* Fragment */],
            null,
            items.map(function (item, index) {
              var catCounter = _this2.props.counter[item.name] > 0 ? '(' + _this2.props.counter[item.name] + ')' : '';

              // Use custom name if available
              var itemName = item.custom_name ? item.custom_name.replace('amp;', '') : item.name.replace('amp;', '');
              var active = _this2.props.currentElements.includes(item.id) ? 'chosen' : '';

              if (index < 10) {
                if (_this2.props.counter[item.name] >= 1) {
                  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                    'div',
                    { className: 'c-shop-filter__checkbox ' + active },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('input', {
                      type: 'checkbox',
                      name: item.name,
                      value: '1',
                      checked: _this2.props.currentElements.includes(item.name),
                      id: item.name,
                      className: 'c-shop-filter__input',
                      onClick: _this2.props.handleChange,
                      'data-target': _this2.props.target,
                      'data-id': item.id,
                      disabled: _this2.props.isLoading
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                      'label',
                      { className: 'c-shop-filter__label', 'for': item.name },
                      itemName,
                      ' ',
                      catCounter
                    )
                  );
                }
              }
            })
          ),
          items.length > 10 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            {
              className: 'c-shop-filter__show-more',
              onClick: this.handleOptions.bind(this)
            },
            this.state.collapsed ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* Fragment */],
              null,
              this.props.showLessLabel,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                'svg',
                { className: 'c-icon c-shop-filter__show-icon u-hide-on-large-down' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#chevron-up', xlinkHref: '#chevron-up' })
              )
            ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              __WEBPACK_IMPORTED_MODULE_0_preact__["b" /* Fragment */],
              null,
              this.props.showMoreLabel,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
                'svg',
                { className: 'c-icon c-shop-filter__show-icon u-hide-on-large-down' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#chevron-down', xlinkHref: '#chevron-down' })
              )
            )
          ) : false,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
            'div',
            { className: 'c-shop-filter__view-results u-hide-on-medium-up' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
              'div',
              {
                className: 'c-shop-filter__results-button',
                onClick: this.props.handleClose
              },
              'View results',
              ' ',
              this.props.allPosts.length ? '(' + this.props.allPosts.length + ')' : null
            )
          )
        )
      );
    }
  }]);

  return Checkboxes;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (Checkboxes);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Filters = function Filters(props) {
  var activeClass = props.currentAnimals.length > 0 || props.currentBrands.length > 0 || props.currentCategories.length > 0 || props.searchText ? 'c-shop-filters c-shop-filters--active' : 'c-shop-filters';
  var allAnimals = props.allAnimals;
  var allCategories = props.allCategories;
  var allBrands = props.allBrands;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: activeClass },
    activeClass === 'c-shop-filters c-shop-filters--active' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'div',
      { className: 'c-shop-filters__container' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
        'div',
        { className: 'c-shop-filters__item c-shop-filters__item--close', onClick: props.handleReset },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
          'div',
          { 'class': 'c-shop-filters__item-content' },
          'Clear all filters'
        )
      ),
      props.currentAnimals.map(function (item) {
        var currentCategory = allAnimals.filter(function (category) {
          return category.id == item;
        });
        var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
        var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Item, { handleRemove: props.handleRemove, target: 'currentAnimals', item: currentCategoryName, id: currentCategoryID, language: props.language });
      }),
      props.currentBrands.map(function (item) {
        var currentCategory = allBrands.filter(function (category) {
          return category.id == item;
        });
        var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
        var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Item, { handleRemove: props.handleRemove, target: 'currentBrands', item: currentCategoryName, id: currentCategoryID, language: props.language });
      }),
      props.currentCategories.map(function (item) {
        var currentCategory = allCategories.filter(function (category) {
          return category.id == item;
        });
        var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
        var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Item, { handleRemove: props.handleRemove, target: 'currentCategories', item: currentCategoryName, id: currentCategoryID, language: props.language });
      }),
      props.searchText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(Search, { handleRemove: props.handleRemoveSearch, label: props.searchText }) : null
    ) : null
  );
};

var Item = function Item(props) {
  var languageArray = [{ id: '', title: 'GE' }, { id: 'en', title: 'GE' }, { id: 'be', title: 'BE' }, { id: 'da', title: 'DK' }, { id: 'fi', title: 'FI' }, { id: 'fr', title: 'FR' }, { id: 'fr-be', title: 'BE' }, { id: 'de', title: 'DE' }, { id: 'it', title: 'IT' }, { id: 'nl', title: 'NL' }, { id: 'no', title: 'NO' }, { id: 'es', title: 'ES' }, { id: 'sv', title: 'SE' }, { id: 'gb', title: 'UK' }, { id: 'us', title: 'US' }];
  var filterLabelLanguage = props.language ? languageArray.find(function (_ref) {
    var id = _ref.id;
    return id === props.language;
  }) : languageArray[0];
  filterLabelLanguage = filterLabelLanguage.title ? filterLabelLanguage.title : '';

  var label = props.label ? props.label.replace('amp;', '') : props.item.replace('amp;', '');
  var filterLabel = label.includes(filterLabelLanguage) ? label.replace('| ' + filterLabelLanguage, '') : label;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-filters__item', onClick: props.handleRemove, 'data-target': props.target, 'data-name': props.item, 'data-id': props.id },
    filterLabel,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'svg',
      { className: 'c-icon c-shop-filters__icon' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#close', xlinkHref: '#close' })
    )
  );
};

var Search = function Search(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
    'div',
    { className: 'c-shop-filters__item', onClick: props.handleRemove },
    props.label,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])(
      'svg',
      { className: 'c-icon c-shop-filters__icon' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* h */])('use', { href: '#close', xlinkHref: '#close' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export disableBodyScroll */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearAllBodyScrollLocks; });
/* unused harmony export enableBodyScroll */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPosition = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

var setPositionFixed = function setPositionFixed() {
  return window.requestAnimationFrame(function () {
    // If previousBodyPosition is already set, don't set it again.
    if (previousBodyPosition === undefined) {
      previousBodyPosition = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };

      // Update the dom inside an animation frame 
      var _window = window,
          scrollY = _window.scrollY,
          scrollX = _window.scrollX,
          innerHeight = _window.innerHeight;

      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY;
      document.body.style.left = -scrollX;

      setTimeout(function () {
        return window.requestAnimationFrame(function () {
          // Attempt to check if the bottom bar appeared due to the position change
          var bottomBarHeight = innerHeight - window.innerHeight;
          if (bottomBarHeight && scrollY >= innerHeight) {
            // Move the content further up so that the bottom bar doesn't hide it
            document.body.style.top = -(scrollY + bottomBarHeight);
          }
        });
      }, 300);
    }
  });
};

var restorePositionSetting = function restorePositionSetting() {
  if (previousBodyPosition !== undefined) {
    // Convert the position from "px" to Int
    var y = -parseInt(document.body.style.top, 10);
    var x = -parseInt(document.body.style.left, 10);

    // Restore styles
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;

    // Restore scroll
    window.scrollTo(x, y);

    previousBodyPosition = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  }
};

var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });

    if (documentListenerAdded) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }

  locks = [];
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  }

  if (isIosDevice) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }
};



/***/ })
],[31]);


// WEBPACK FOOTER //
// main.f31a3aa44d83113e03e9.js